import styled from '@emotion/styled'
import React, { ComponentProps } from 'react'

import { Link } from '@emico/link'
import { overrideOptional } from '@emico/overrides'
import { theme } from '@emico/styles'
import { Container } from '@emico/ui'

const StyledContainer = styled(Container)`
  display: flex;
  flex-flow: row wrap;
`
const StyledBar = styled.div`
  background: ${theme.primary500};
  color: ${theme.onPrimaryColor};
  border-bottom: 1px solid ${theme.gray100};
  padding: 10px 0;

  a {
    color: inherit;

    &:hover {
      color: darken(${theme.onPrimaryColor}, 15%);
    }
  }
`
const StyledUsps = styled.div`
  flex: 1 0 auto;
  width: auto;
`
const StyledContact = styled.div`
  flex: 1 0 auto;
  width: auto;
`

const HeaderUspBar = (props: ComponentProps<typeof StyledBar>) => {
  // TODO: Pull from Prismic
  const topBarUsp = 'Gratis verzending vanaf 50,-'
  // TODO: Pull from store config https://support.emico.nl/issues/120533 depends on backend: https://support.emico.nl/issues/120449
  const phone = '085 888 77 44'
  const email = 'info@emico.nl'

  return (
    <StyledBar {...props}>
      <StyledContainer>
        <StyledUsps>{topBarUsp}</StyledUsps>
        <StyledContact>
          <Link
            to={`tel:${phone}`}
            analyticsContext="header.uspBar"
            analyticsName="Phone"
          >
            {phone}
          </Link>{' '}
          |{' '}
          <Link
            to={`mailto:${email}`}
            analyticsContext="header.uspBar"
            analyticsName="Email"
          >
            {email}
          </Link>
        </StyledContact>
      </StyledContainer>
    </StyledBar>
  )
}

export default overrideOptional(HeaderUspBar)
